import React from 'react';
import { styled } from 'linaria/react';
import { ElevateProductRecommendation } from '../ElevateProductRecommendation';

const ElevateRecommendationsWrapper = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 40px;
  margin-top: 45px;
`;
export const ElevateRecommendationsHandler = ({
  noTitle,
  recommendationsLists,
  title,
  slidesToShowDesktop,
  slidesToShowMobile,
  showVariants = true,
  clickCallback = () => {}
}) => {
  if (!recommendationsLists?.length) return null;
  return (
    <ElevateRecommendationsWrapper>
      {recommendationsLists?.map((recommendationObject, index) => (
        <ElevateProductRecommendation
          key={recommendationObject?.id}
          noTitle={noTitle}
          recommendationObject={recommendationObject}
          title={index === 0 ? title : null}
          slidesToShowDesktop={slidesToShowDesktop}
          slidesToShowMobile={slidesToShowMobile}
          showVariants={showVariants}
          clickCallback={clickCallback}
        />
      ))}
    </ElevateRecommendationsWrapper>
  );
};
